/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Input, Modal } from 'antd';
import EditTable from '../EditTable';
import {
    updateCoordinate,
    updateDesc,
    updateName,
    updatePlaceName,
    updateSelectFieldType
} from '@/redux/reducer/SoilCreatProfiles';
import './index.less';
import { RootState } from '@/redux';
import GoogleMapReact from '@/components/GoogleMapReact';
import TextArea from 'antd/lib/input/TextArea';
import { soilProfileGetPlaceNameByLatLong } from '@/util/Request';
import { SoilCloseIcon } from '@/resource/IconComponentSets';

const { confirm } = Modal;

export default function AddNewSoilProfile() {
    const [mapVisible, setMapVisible] = useState(false);

    const {
        name,
        coordinate,
        selectFieldType,
        desc,
        fieldTypes,
        actionType,
        placeName,
        status,
        fieldRequiredCheckModel
    } = useSelector((state: RootState) => state.soilprofileCreateData);
    // SECTION:  usecallback area
    useEffect(() => {
        if (fieldTypes.length > 0) {
            // default set fieldType !!!!
            dispatch(updateSelectFieldType(fieldTypes[0].fieldTypeId));
        }
    }, [fieldTypes]);

    const dispatch = useDispatch();

    const handleNameInputValueOnChange = (e) => {
        dispatch(updateName(e.target.value));
    };

    const handleDescInputValueOnChange = (e) => {
        dispatch(updateDesc(e.target.value));
    };

    const handleCoordinateValueChange = (e) => {
        dispatch(updateCoordinate(e.target.value));
    };

    const updatePlaceGeoInfo = async () => {
        try {
            if (!coordinate || coordinate && coordinate.length === 0) {
                return;
            }
            const coordinateArr = coordinate.split(',');
            if (coordinateArr.length !== 2) {
                return showCoordinateInvalidate('Coordinate is invalidate!');
            }
            const lonReg = /^[-+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/;
            const latReg = /^[-+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/;
            const lonValidate = lonReg.test(coordinateArr[0].replace(/\s+/g, ''));
            const latValidate = latReg.test(coordinateArr[1].replace(/\s+/g, ''));
            if (lonValidate && latValidate) {
                const lat = parseFloat(coordinateArr[1]);
                const lng = parseFloat(coordinateArr[0]);
                const res = await soilProfileGetPlaceNameByLatLong(lat, lng);
                const targetGeoName = res.geonames[0];
                if (targetGeoName) {
                    targetGeoName.lat = lat;
                    targetGeoName.lng = lng;
                    dispatch(updatePlaceName(targetGeoName));
                }
            } else {
                if (!latValidate) {
                    showCoordinateInvalidate('Latitude invalidate!');
                }
                if (!lonValidate) {
                    showCoordinateInvalidate('Longitude invalidate!');
                }
            }
        } catch(err) {
            console.log('err:===', err);
        }
    };

    const handleCoordinateValueOnBlur = async (e) => {
        const value: string = e.target.value;
        if (!value || value && value.length === 0) {
            return;
        }
        const valueArr = value.split(',');
        if (valueArr.length !== 2) {
            return showCoordinateInvalidate('Coordinate isn\'t complete!');
        }
        const lonReg = /^[-+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/;
        const latReg = /^[-+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/;

        const lonValidate = lonReg.test(valueArr[0].replace(/\s+/g, ''));
        const latValidate = latReg.test(valueArr[1].replace(/\s+/g, ''));
        if (lonValidate && latValidate) {
            dispatch(updateCoordinate(e.target.value));
        } else {
            if (!latValidate) {
                showCoordinateInvalidate('Latitude invalidate!');
            }
            if (!lonValidate) {
                showCoordinateInvalidate('Longitude invalidate!');
            }
        }
        const res = await soilProfileGetPlaceNameByLatLong(parseFloat(valueArr[1]), parseFloat(valueArr[0]));
        if (!res.geonames || res.geonames && res.geonames.length === 0) {
            showNoMatchLocation();
        }
        const targetGeoName = res.geonames[0];
        targetGeoName.lat = parseFloat(valueArr[1]);
        targetGeoName.lng = parseFloat(valueArr[0]);
        if (targetGeoName) {
            // dispatch(updateCoordinate(`${targetGeoName.lat},${targetGeoName.lng}`));
            dispatch(updatePlaceName(targetGeoName));
        }
    };

    useEffect(() => {
        if (mapVisible) {
            handleCoordinateValueOnBlur({ target: { value: coordinate } });
        }
    }, [coordinate]);

    const showCantEditCoordinateMessage = () => {
        confirm({
            title: 'Error',
            content: 'under edit model cannot edit coordinate!',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };
    const showNoMatchLocation = () => {
        confirm({
            title: 'Warning',
            content: 'No location match current coordinate!',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };
    const showCoordinateInvalidate = (msg: string) => {
        confirm({
            title: 'Error',
            content: msg,
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handleButtonClick = (index) => {
        const selectFieldId = fieldTypes[index].fieldTypeId;
        dispatch(updateSelectFieldType(selectFieldId));
    };

    const handleFindOnMapClick = () => {
        if (actionType === 'edit' && status !== 'Draft') {
            return showCantEditCoordinateMessage();
        }
        console.log('111111111111111111111111111111111111111111111');
        setMapVisible(true);
    };

    return (
        <div className='add-soil-modal-container'>
            <Modal
                open={mapVisible}
                width='950px'
                centered
                title={<span className='map-modal-title-span'>{actionType === 'edit' ? 'Edit' : 'Add'} Soil Profile</span>}
                onCancel={() => {
                    console.log('2222222222222222222222222222222222222222222222222222222222222');
                    setMapVisible(false);
                    updatePlaceGeoInfo();
                }}
                onOk={() => {
                    console.log('333333333333333333333333333333333333333333333333333333333333333333');
                    setMapVisible(false);
                    updatePlaceGeoInfo();
                }}
                footer={null}
                style={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    height: '650px',
                }}
                closeIcon={<SoilCloseIcon />}
                destroyOnClose={true}
            >
                <GoogleMapReact
                    type={'FIND'}
                    includePanel={true}
                    actionPanelCloseCallBack={() => {
                        setMapVisible(false);
                    }}
                    showPolyMenu={false}
                />
            </Modal>
            <div className='soil-name-input-div'>
                <label>{fieldRequiredCheckModel && !name && <label className='require-mark-label'>*</label>}Name</label>
                <Input status={fieldRequiredCheckModel && !name ? 'error' : null} onChange={handleNameInputValueOnChange} value={name} className='soil-profile-add-input' />
                {fieldRequiredCheckModel && !name ? <span className='required-field-notice'>name field is required!</span> : null}
            </div>
            <div className='soil-desc-input-div'>
                <label>Description</label>
                <TextArea onChange={handleDescInputValueOnChange} value={desc} className='soil-profile-add-textarea' />
            </div>
            <div className='soil-coordinate-input-div'>
                <div>
                   <label>{fieldRequiredCheckModel && !coordinate && <label className='require-mark-label'>*</label>}Coordinates<label className='gray-label'>(Long,lat)</label></label>
                    <button onClick={handleFindOnMapClick}>Find on map</button>
                </div>
                <Input
                    status={fieldRequiredCheckModel && !coordinate ? 'error' : null}
                    onChange={handleCoordinateValueChange}
                    value={coordinate}
                    onBlur={handleCoordinateValueOnBlur}
                    placeholder='e.g.165.2446,44.17943'
                />
                {fieldRequiredCheckModel && !coordinate ? <span className='required-field-notice'>coordinate field is required!</span> : null}
            </div>
            <div className='select-country-div'>
                <span>{placeName && placeName.countryName} {placeName && placeName.adminName1}</span>
            </div>
            <div className='field-type-row'>
                <span>
                    Field type
                </span>
            </div>
            <div className='swith-type-div'>
                {fieldTypes.map((item, index) => (
                    <button
                        key={item.fieldTypeId}
                        className={selectFieldType === item.fieldTypeId ? 'button-select' : 'button-unselect'}
                        onClick={() => handleButtonClick(index)}
                    >
                        { item.fileTypeName }
                    </button>
                ))}
            </div>
            <div className='add-soil-table-row'>
                <h4 className='soil-layer-list-header'>Soil Layers</h4>
                <EditTable />
            </div>
        </div>
    );
}
